import {ref, Ref, watch} from '@vue/composition-api';
import {ErrorsNotifier} from '../../../core/error/ErrorsNotifier';

export class EditorCurrentUserControllerClass {
	private static _instance: EditorCurrentUserControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorCurrentUserControllerClass());
	}

	private _username!: Ref<string | null>;
	private constructor() {}

	init() {
		this._username = ref(null);

		watch(this._username, () => {
			ErrorsNotifier.updateMetadata();
		});
	}

	username() {
		return this._username;
	}

	setUsername(username: string) {
		this._username.value = username;
	}
}

export const EditorCurrentUserController = EditorCurrentUserControllerClass.instance();
